import { render, staticRenderFns } from "./OrderPrices.vue?vue&type=template&id=41cd48ac&scoped=true&"
import script from "./OrderPrices.vue?vue&type=script&lang=js&"
export * from "./OrderPrices.vue?vue&type=script&lang=js&"
import style0 from "./OrderPrices.vue?vue&type=style&index=0&id=41cd48ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd48ac",
  null
  
)

export default component.exports